import React from "react"
import ReactDOM from "react-dom/client"
import App from "./App"
import { store } from "./store/store"
import { Provider } from "react-redux"
import { BrowserRouter } from "react-router-dom"
import { ErrorBoundary  } from 'react-error-boundary';

import "./styles/css/bootstrap-icons.css"
import "./styles/css/theme.css"
import GlobalStyle from "./styles/GlobalStyle"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import Error from "./components/pages/Error"

const root = ReactDOM.createRoot(document.getElementById("root"))
const queryClient = new QueryClient({
    // 전역 처리 - 네트워크 에러, 타임아웃, 일시적 서버 오류(502, 503, 504)일 때만 재시도
    // 각 훅에서 retry 값을 넣는다면 훅 설정이 우선되고 이 queryClient 처리가 중복으로 실행되진 않는다.
    defaultOptions: {
        queries: {
			retry: (failureCount, error) =>
				!error.response || error.code === 'ECONNABORTED' || [502, 503, 504].includes(error.response.status),
            retryDelay: (attemptIndex) => 500 * attemptIndex,
        },
        mutations: {
            retry: (failureCount, error) =>
				!error.response || error.code === 'ECONNABORTED' || [502, 503, 504].includes(error.response.status),
            retryDelay: (attemptIndex) => 500 * attemptIndex,
        },
    },
})

// DEV 환경이면 document.title에 (dev) 추가
let title = 'AIRS'
if (process.env.REACT_APP_STAGE === 'development') title += ' (dev)'
document.title = title

root.render(
    <Provider store={store}>
        <QueryClientProvider client={queryClient}>
            <BrowserRouter>
                <ErrorBoundary fallback={<Error />}>
                    <GlobalStyle />
                    <App />
                </ErrorBoundary>
            </BrowserRouter>
        </QueryClientProvider>
    </Provider>
)